module.exports = __webpack_public_path__ + "img/eye-icon.db54fb8a.svg";